export const ACTION_OPTIONS = [
    { label: 'ללא', value: '' },
    { label: 'פופאפ הרצאות', value: 'open_lectures' },
    { label: 'פופאפ קהילה', value: 'open_community' },
    { label: 'פופאפ הטבות', value: 'open_benefits' }
]
